<template>
  <div>
    <b-container fluid>
      <b-col
        cols="12"
        lg="8"
        xl="6"
        class="mx-auto"
      >
        <b-img
          v-if="congress && congress.bgBanner"
          :src="congress.bgBanner"
          fluid
          alt="Congress Banner"
          class="w-100 mb-4"
        />
      </b-col>
    </b-container>
    <b-container fluid>
      <!-- Top: Basic Info + Dates -->
      <b-row class="mb-4">
        <b-col
          cols="12"
          lg="8"
          class="d-flex"
        >
          <congress-info-card
            :congress="congress"
            class="flex-fill d-flex flex-column"
          />
        </b-col>
        <b-col
          cols="12"
          lg="4"
          class="d-flex"
        >
          <congress-dates-location-card
            :congress="congress"
            class="flex-fill d-flex flex-column"
          />
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-col
          cols="12"
          lg="6"
          class="d-flex"
        >
          <b-card
            img-src="https://www.hcs.gr/wp-content/uploads/2025/09/seminar-executive-room-in-hotel.jpg"
            :img-alt="$t('Sessions')"
          >
            <b-card-text>
              <h1 class="text-center">
                <a
                  :href="`https://www.hcs.gr/scientific-programme/${congress.websiteId}`"
                  target="_blank"
                  class="text-secondary"
                >{{ $t('Sessions') }}</a>
              </h1>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col
          cols="12"
          lg="6"
          class="d-flex"
        >
          <b-card
            img-src="https://www.hcs.gr/wp-content/uploads/2025/09/men-standing-on-camera-at-the-event.jpg"
            :img-alt="$t('Videos')"
          >
            <b-card-text>
              <h1 class="text-center">
                <a
                  :href="`https://www.hcs.gr/web-tv-videos/${congress.websiteId}`"
                  target="_blank"
                  class="text-secondary"
                >{{ $t('Videos') }}</a>
              </h1>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <div v-if="links.length > 0">
        <h1 class="text-center mt-3 pb-2">
          {{ $t('Congress Sections') }}
        </h1>
        <b-row class="mb-4">
          <b-col
            v-for="link in links"
            :key="link.id"
            cols="12"
            md="6"
            lg="4"
            class="d-flex"
          >
            <b-card
              :title="link.title"
              class="flex-fill d-flex flex-column"
            >
              <template #header>
                <feather-icon
                  icon="LinkIcon"
                  size="24"
                />
              </template>
              <b-card-text
                class="flex-grow-1"
                v-html="link.excerpt"
              />

              <b-button
                variant="outline-primary"
                :href="link.url"
                size="sm"
                target="_blank"
                class="mt-2 align-self-start"
              >
                {{ $t('Read More') }}
              </b-button>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
import { BContainer, BRow, BCol } from 'bootstrap-vue'
import CongressInfoCard from './CongressInfoCard.vue'
import CongressDatesLocationCard from './CongressDatesLocationCard.vue'
import axios from 'axios'

export default {
  components: {
    BContainer,
    BRow,
    BCol,
    CongressInfoCard,
    CongressDatesLocationCard,
  },
  data() {
    return {
      congressApi: null,
      links: [],
    }
  },
  computed: {
    congress() {
      if (!this.congressApi) return {}
      return {
        ...this.congressApi,
        location: this.congressApi.venue ? this.congressApi.venue.title : '-',
        category: this.congressApi.category ? this.congressApi.category.title : '-',
        status: this.congressApi.status.title,
      }
    },
  },
  mounted() {
    this.$store.dispatch('app-common/fetchCongress', this.$route.params.id).then(response => {
      this.congressApi = response.data
      if (this.congressApi.websiteId) {
        axios.get(`${process.env.VUE_APP_WEBSITE_URL}wp-json/wp/v2/events/?parent=${this.congressApi.websiteId}`).then((res) => {
          this.links = res.data.map(link => ({
            id: link.id,
            title: link.title.rendered,
            url: link.link,
            date: link.date,
            excerpt: link.excerpt.rendered
          }))
        })
      }
    })
  },
}
</script>
